import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../settings/variables/Colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as faSolidStar } from '@fortawesome/pro-solid-svg-icons';
import { faStar, IconDefinition } from '@fortawesome/pro-light-svg-icons';
import { SPACERS } from '../settings/variables/Spacers';

interface TrueImpactRatingProps {
  count: number;
  value: number;
  starSize?: number;
  handleChange: (value: number) => unknown;
}

const StyledDiv = styled.div<{ starSize: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${SPACERS.tiny};
  .star {
    cursor: pointer;
    ${({ starSize }) => `width: ${starSize}px; height: ${starSize}px;`}
  }
`;

const TrueImpactRating: React.FC<TrueImpactRatingProps> = ({
  value,
  count,
  starSize = 24,
  handleChange,
}) => {
  const stars: React.ReactNode[] = [];
  for (let i = 0; i < count; i++) {
    const isActive = value >= i + 1;
    const color = isActive ? COLORS.ctaBrand : undefined;
    stars.push(
      <FontAwesomeIcon
        key={i}
        color={color}
        icon={isActive ? (faSolidStar as IconDefinition) : faStar}
        className="star"
        onClick={() => handleChange(i + 1)}
      />,
    );
  }
  return <StyledDiv starSize={starSize}>{stars}</StyledDiv>;
};

export default TrueImpactRating;
